<script lang="ts">import Header from "./header.svelte";
import Notification from "./notification.svelte";
import { markAllAsRead, notificationsStore, showOnlyUnread, showPersonalNotifications } from "../state";
import { Button } from "@infinitro/button";
import { cfgToThemeCdnPath, FeatureSet, stateFeatureSet } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { Text } from "@infinitro/text";
let personalNotifications = false;
let showUnreadOnly = false;
showPersonalNotifications.subscribe((value) => {
	personalNotifications = value;
});
showOnlyUnread.subscribe((value) => {
	showUnreadOnly = value;
});
$: getUnreadNotifications = () => {
	return $notificationsStore.filter((notification) => !notification.read);
};
$: console.log("notificationsStore", $notificationsStore);
</script>

<div class="notifications-list">
	<div class="header-container">
		<Header />
	</div>
	<div class="notifications-container">
		{#if personalNotifications}
			{#each $notificationsStore as notification}
				{#if notification.personal && (!showUnreadOnly || !notification.read)}
					<Notification {notification} />
				{/if}
			{/each}

			<!-- Personal Empty Notifications -->
			{#if $notificationsStore.filter((notification) => notification.personal && (!showUnreadOnly || !notification.read)).length === 0}
				<div class="empty-illustration-container">
					<img
						src={cfgToThemeCdnPath(`/notifications/empty-notifications-illustration.svg`)}
						alt={$t(Verbiage.illustration_alt, 'alts')}
						class="empty-illustration"
					/>

					<div class="empty-notifications-message">
						<Text textColor="gray" textAlign="center" type="subtitle" subtitleSize="large">
							{$t(Verbiage.empty_personal_notifications_message)}
						</Text>
					</div>
				</div>
			{/if}
		{:else}
			{#each $notificationsStore as notification}
				{#if !notification.personal && (!showUnreadOnly || !notification.read)}
					<Notification {notification} />
				{/if}
			{/each}

			<!-- Platform Empty Notifications -->
			{#if $notificationsStore.filter((notification) => !notification.personal && (!showUnreadOnly || !notification.read)).length === 0}
				<div class="empty-illustration-container">
					<img
						src={cfgToThemeCdnPath(`/notifications/empty-notifications-illustration.svg`)}
						alt={$t(Verbiage.illustration_alt, 'alts')}
						class="empty-illustration"
					/>

					<div class="empty-notifications-message">
						<Text textColor="gray" textAlign="center" type="subtitle" subtitleSize="large">
							{$t(Verbiage.empty_platform_notifications_message)}
						</Text>
					</div>
				</div>
			{/if}
		{/if}
	</div>
	{#if getUnreadNotifications().length !== 0 && $stateFeatureSet === FeatureSet.Preview}
		<div class="button-container">
			<Button
				text={$t(Verbiage.mark_all_as_read)}
				uppercase
				variant="tertiary"
				fullWidth
				onClick={markAllAsRead}
			/>
		</div>
	{/if}
</div>

<style>
	.button-container {
		padding-top: 0.75rem;
		padding-bottom: 0.75rem;
}

	.empty-notifications-message {
		margin-top: -1rem;
		width: 100%;
		text-align: center;
}

	.empty-illustration {
	}

	.empty-illustration-container {
		height: calc(100% - 40%);
		position: absolute;
		top: 0px;
		--tw-translate-y: 60%;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
	}

	@media (min-width: 1024px) {
		.empty-illustration-container {
				position: relative;
				top: 0px;
				--tw-translate-y: 60%;
				transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
		}
	}
</style>
